import {
  Card,
  Avatar,
  Image,
  Text,
  Button,
  Divider,
  Modal,
  Space,
  Title,
  Container,
  Box,
} from "@mantine/core";
import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import classes from "./FeatureCard.module.css";
import I18n from "../../i18n.js";
import parse from "html-react-parser";
import React from "react";

interface FeatureCardProps {
  featureName: React.ReactNode; // Changed from string to ReactNode
  featureText: string;
  longText: string;
  modalText: string;
  icon: React.ElementType;
  image: string;
}

export function FeatureCard({
  featureName,
  featureText,
  longText,
  modalText,
  icon: Icon,
  image,
}: FeatureCardProps) {
  const [opened, { open, close }] = useDisclosure(false);
  const isMobile = useMediaQuery("(max-width: 50em)");
  
  // This will handle converting ReactNode to string for alt text
  const getTitleText = () => {
    if (typeof featureName === 'string') {
      return featureName;
    }
    // If it's a ReactNode, return a generic alt text
    return "Feature image";
  };
  
  return (
    <>
      <Modal
        size="lg"
        opened={opened}
        onClose={close}
        title={<Title>{featureName}</Title>}
        fullScreen={isMobile}
      >
        <Space h="md" />
        {<Image radius="md" src={image} />}
        <Space h="md" />
        <Divider />
        <Space h="md" />
        <Text pb="20px" pl="10px" pr="10px">{parse(modalText)}</Text>
        <Divider />
        <Button
          fullWidth
          className={classes.button}
          color={"#FEBF0E"}
          variant="outline"
          onClick={() => {
            close();
          }}
        >
          {I18n.t("general.close")}
        </Button>
      </Modal>
      <Card
        w={"20%"}
        withBorder
        padding="xl"
        radius="md"
        className={classes.card}
      >
        <Card.Section h={140} className={classes.imageContainer}>
          <Image src={image} height={140} alt={getTitleText()} />
          <div className={classes.imageOverlay}></div>
        </Card.Section>
        <Avatar
          size={90}
          radius={80}
          mx="auto"
          mt={-30}
          className={classes.avatar}
        >
          <Icon size="50" color={"#FEBF0E"}/>
        </Avatar>
        <Card.Section className={classes.contentSection}>
          <div className={classes.titleContainer}>
            {featureName}
          </div>
          <Text ta="center" fz="sm" c="dimmed">
            {featureText}
          </Text>
          <Divider my="sm" />
          <Container w={"90%"}>
            <Text ta="center" fz="sm" c="dimmed">
              {longText}
            </Text>
          </Container>
        </Card.Section>
        <Space h="xs" />
        <Button
          fullWidth
          radius="md"
          mt="lg"
          size="md"
          variant="light"
          color={"#FEBF0E"}
          onClick={open}
        >
          {I18n.t("general.learnMore")}
        </Button>
      </Card>
    </>
  );
}